import { Checkbox, Text } from "@fluentui/react-components";
import { useAtom, useAtomValue } from "jotai";
import { selectedStatusFilterAtom } from "store";
import { benefitContentTabAtom } from "store/UIBenefitsPage";

import { Flex } from "components/styled";

type Props = {
  id: string;
  name: string;
};

export function StatusFilterItem({ id, name }: Props) {
  const [statusFilters, setStatusFilters] = useAtom(selectedStatusFilterAtom);
  const selectedContentTab = useAtomValue(benefitContentTabAtom);

  const isFiltered = statusFilters[selectedContentTab]?.find((item) => item.id === id);

  return (
    <Flex key={id}>
      <Checkbox
        checked={!!isFiltered}
        onChange={(_, data) => {
          const checked = data.checked;

          if (checked) {
            setStatusFilters((prev) => {
              return {
                ...prev,
                [selectedContentTab]: [...(prev[selectedContentTab] || []), { id, name }],
              };
            });
          } else {
            setStatusFilters((prev) => {
              return {
                ...prev,
                [selectedContentTab]: prev[selectedContentTab].filter((item) => item.id !== id),
              };
            });
          }
        }}
      />
      <Text>{name}</Text>
    </Flex>
  );
}
